/**
 * Ad Configuration
 * 
 * Toggle this to show/hide all ad placeholders across the site.
 * Set to `true` when you're ready to display ads.
 */

export const AD_CONFIG = {
  // Set to true to show ad placeholders, false to hide them
  SHOW_ADS: true,
  
  // Your Google AdSense Publisher ID (optional - for reference)
  // ADSENSE_CLIENT_ID: "ca-pub-XXXXXXXXXXXXXXXX",
};

/**
 * HOW TO ADD YOUR AD CODES:
 * 
 * 1. Open /app/frontend/src/components/AdPlacement.jsx
 * 
 * 2. Find the AdPlacement component and replace the placeholder return with your ad code.
 *    
 *    Example for Google AdSense:
 *    
 *    ```jsx
 *    export function AdPlacement({ slot, size, className }) {
 *      useEffect(() => {
 *        try {
 *          (window.adsbygoogle = window.adsbygoogle || []).push({});
 *        } catch (e) {}
 *      }, []);
 *      
 *      return (
 *        <ins className="adsbygoogle"
 *          style={{ display: "block" }}
 *          data-ad-client="ca-pub-XXXXXXXXXXXXXXXX"
 *          data-ad-slot="XXXXXXXXXX"
 *          data-ad-format="auto"
 *          data-full-width-responsive="true"
 *        />
 *      );
 *    }
 *    ```
 * 
 * 3. Add the AdSense script to your index.html:
 *    
 *    ```html
 *    <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-XXXXXXXXXXXXXXXX" crossorigin="anonymous"></script>
 *    ```
 * 
 * 4. Set SHOW_ADS to true in this file.
 * 
 * 
 * FOR OTHER AD NETWORKS (Mediavine, Ezoic, etc.):
 * - Follow their specific integration guides
 * - Replace the AdPlacement component return with their ad code
 * - Most networks provide a script tag + div placeholder
 */

export default AD_CONFIG;
